import * as Notifications from 'expo-notifications';
import { useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

Notifications.setNotificationHandler({
    handleNotification: async () => ({
        shouldShowAlert: true,
        shouldPlaySound: false,
        shouldSetBadge: false,
    }),
});

const useLocalNotification = () => {
    useEffect(() => {
        const foregroundSubscription = Notifications.addNotificationReceivedListener(notification => {
            console.log(notification);
        });

        const responseSubscription = Notifications.addNotificationResponseReceivedListener(response => {
            console.log(response);
        });

        return () => {
            foregroundSubscription.remove();
            responseSubscription.remove();
        };
    }, []);

    const scheduleNotification = async (title, body, data = {}) => {
        const notificationData = {
            ...data,
            url: 'cbc://snooze'
        };

        const identifier = await Notifications.scheduleNotificationAsync({
            content: {
                title,
                body,
                data: notificationData,
                sound:true
            },
            trigger: { seconds: notificationData.seconds , repeats: false },
        });
        return identifier;
    };

    // Iterates through days of the week and creates a scheduled notification for each.
    //If body reads "false", use getCurrentNotificationMessage.
    const scheduleRecurringNotification = async (title, body, time, daysOfWeek, data = {}) => {

        if(typeof time.getHours !== 'function'){
            time = new Date(time);
        }
        const hour = time.getHours();
        const minute = time.getMinutes();
        const notificationData = {
            ...data,
            url: 'cbc://snooze'
        };
        let notifications = [];
        for (const day of daysOfWeek) {
            const trigger = {
                hour,
                minute,
                weekday: day,
                repeats: true,
            };

            // Check and fetch new body message for each day if necessary
            let dayBody = body; // Use a local variable to handle the body for each day
            if (body === false) {
                dayBody = await getCurrentNotificationMessage(); // Fetch new message for each day
            }

            const identifier = await Notifications.scheduleNotificationAsync({
                content: {
                    title,
                    body: dayBody, // Use day-specific body message
                    sound: true,
                    data: notificationData
                },
                trigger,
            });

            notifications.push({
                identifier,
                trigger,
                originalTimestamp: time,
                content: {
                    title,
                    body: dayBody, // Use day-specific body message
                    data: notificationData, // Ensure notification data is included
                },
            });
        }
        return notifications;
    };

    const cancelNotification = async (identifier) => {
        await Notifications.cancelScheduledNotificationAsync(identifier);
    };

    const getAllScheduledNotifications = async () => {
        return await Notifications.getAllScheduledNotificationsAsync();
    };

    const getCurrentNotificationMessage = async () => {
        const messageListStr = await AsyncStorage.getItem('reminderMessages');
        const messageList = JSON.parse(messageListStr);

        let currentIndexStr = await AsyncStorage.getItem('reminderMessageListLastIndex');
        let currentIndex = Number(currentIndexStr);
        currentIndex = (currentIndex + 1) % messageList.length;

        await AsyncStorage.setItem('reminderMessageListLastIndex', currentIndex.toString());
        return messageList[currentIndex];
    }




    return { scheduleNotification, scheduleRecurringNotification, cancelNotification, getAllScheduledNotifications };
};

export default useLocalNotification;
